/**
 * Shared caption formatter for Display Check photos.
 *
 * Every photo record carries snapshots (zone_name, display_area_code/name,
 * captured_at, photo_type) at the moment of capture. This helper turns those
 * snapshots into the strings shown beneath each photo — in the DisplayRun
 * capture grid, on DisplayDetail review, and in the PDF report.
 */
export function formatPhotoCaption(p) {
  if (!p) return { primary: "", secondary: "", zone: "", area: "", when: "", type: "" };
  const areaCode = p.display_area_code_snapshot || p.display_area_code || "";
  const areaName = p.display_area_name_snapshot || p.display_area_name || "";
  const zone = p.zone_name_snapshot || "";
  const t = p.captured_at || p.taken_at;
  let when = "";
  if (t) {
    const d = new Date(t);
    if (!isNaN(d.getTime())) {
      when = d.toLocaleString("en-US", {
        month: "short", day: "2-digit", hour: "numeric", minute: "2-digit",
      });
    }
  }
  const type = (() => {
    const t = String(p.photo_type || "").toLowerCase();
    if (t === "issue") return "ISSUE";
    if (t === "correction") return "CORRECTION";
    // "zone" is the backend's internal label for regular inspection photos —
    // don't surface it. Anything else uppercase-and-render (spec labels).
    if (t && !["zone", "inspection", ""].includes(t)) return t.toUpperCase();
    return "";
  })();
  const area = [areaCode, areaName].filter(Boolean).join(" • ");
  const primary = area || zone || "";
  const secondaryBits = [];
  if (zone && area) secondaryBits.push(zone);
  if (when) secondaryBits.push(when);
  if (type) secondaryBits.push(type);
  return { primary, secondary: secondaryBits.join(" · "), zone, area, when, type };
}
